import type { CapexBreakdown } from '../utils/financialCalculations';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Cell, LabelList } from 'recharts';

function fmt(v: number): string { return Math.abs(v) >= 1e6 ? `€${(v / 1e6).toFixed(1)}M` : `€${(v / 1e3).toFixed(0)}k`; }
const COLORS = ['#0891B2', '#3B82F6', '#D97706', '#059669', '#475569', '#8B5CF6', '#F59E0B', '#0B1F4A'];

export default function CapexWaterfallChart({ capex, printMode }: { capex: CapexBreakdown; printMode?: boolean }) {
  const items = [
    { name: 'PV', value: capex.pv }, { name: 'BESS', value: capex.bess }, { name: 'Backup', value: capex.backup },
    { name: 'Laadinfra', value: capex.chargers }, { name: 'Netaansl.', value: capex.gridConnection },
    { name: 'Engineering', value: capex.engineering },
    ...(capex.customCapex > 0 ? [{ name: 'Overig', value: capex.customCapex }] : []),
    { name: 'TOTAAL', value: capex.total },
  ];
  let running = 0;
  const data = items.map((item, i) => {
    const isTotal = i === items.length - 1;
    const offset = isTotal ? 0 : running;
    if (!isTotal) running += item.value;
    return { ...item, offset, display: item.value };
  });
  return (
    <div className="bg-white rounded-xl border border-[#D9E2EC] p-4 shadow-sm mb-4">
      <div className="text-xs font-bold text-[#0B1F4A] mb-1">🏗️ CAPEX Waterval</div>
      <div className="text-[10px] text-[#8899AA] mb-3">Opbouw totale investering</div>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} barCategoryGap="20%">
          <XAxis dataKey="name" tick={{ fontSize: 10 }} />
          <YAxis tick={{ fontSize: 10 }} tickFormatter={v => fmt(v)} />
          <Tooltip formatter={(v: number) => [fmt(v), 'Bedrag']} />
          <Bar dataKey="offset" stackId="a" fill="transparent" isAnimationActive={!printMode} />
          <Bar dataKey="display" stackId="a" radius={[4, 4, 0, 0]} isAnimationActive={!printMode}>
            {data.map((_, i) => <Cell key={i} fill={COLORS[i]} />)}
            <LabelList dataKey="display" position="top" formatter={(v: number) => fmt(v)} style={{ fontSize: 9, fontWeight: 600, fill: '#0B1F4A' }} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
